import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Icon} from '@components/common/base/icon'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {pendingCompaniesAdminStore} from '@components/dashboard/company-users/pending-companies-admin-store'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {MenuButtonPage} from '../components/menu-button-page'
import {projectsPage} from '../constants'
import {ProjectsList} from './projects-list'

export const ProjectsMenuItem = observer(() => {
  const forceUpdate = useForceUpdate()
  useSyncEvent(
    'profile',
    {debounceTime: 50, filter: globals.currentUserId},
    forceUpdate
  )

  const after = pendingCompaniesAdminStore.state.pendingRegistrationsIds
    .length ? (
    <Tooltip
      content={Lang.msg.menu.newPendingRegistrationsHint}
      offset={[0, 5]}
      placement="right"
    >
      <Icon
        color="notification-primary"
        icon="IconAlertCircle"
        className="ml-auto mr-8"
      />
    </Tooltip>
  ) : undefined

  return (
    <>
      <MenuButtonPage
        page={projectsPage}
        text={Lang.msg.menu.myCompanyHint}
        icon="IconBriefcase"
        after={after}
      />
      <ProjectsList />
    </>
  )
})
